module.exports = __webpack_public_path__ + "static/media/table.69bd3579.png";